/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/AttributeRequest', 'model/AttributeResponse', 'model/AttributeSetRequest', 'model/AttributeSetResponse', 'model/BuildingV2Request', 'model/BuildingV2Response', 'model/BusinessRequest', 'model/BusinessResponse', 'model/CatalogueRequest', 'model/CatalogueResponse', 'model/CategoryRequest', 'model/CategoryResponse', 'model/ConfigurationRequest', 'model/ConfigurationResponse', 'model/DeliveryItemV2Request', 'model/DeliveryItemV2Response', 'model/DeliveryV2Request', 'model/DeliveryV2Response', 'model/FlowItemRequest', 'model/FlowItemResponse', 'model/FlowRequest', 'model/FlowResponse', 'model/GoogleChartOptionsRequest', 'model/GoogleChartOptionsResponse', 'model/InvoiceItemV2Request', 'model/InvoiceItemV2Response', 'model/InvoiceV2Request', 'model/InvoiceV2Response', 'model/LocationV2Request', 'model/LocationV2Response', 'model/LoginRequest', 'model/LoginResponse', 'model/OrderItemV2Request', 'model/OrderItemV2Response', 'model/OrderV2Request', 'model/OrderV2Response', 'model/PartRequest', 'model/PartResponse', 'model/ProductRequest', 'model/ProductResponse', 'model/PublisherRequest', 'model/PublisherResponse', 'model/SettingsRequest', 'model/SettingsResponse', 'model/SiteV2Request', 'model/SiteV2Response', 'model/StationRequest', 'model/StationResponse', 'model/StatisticsRequest', 'model/StatisticsResponse', 'model/StripeAccountEventRequest', 'model/StripeAccountRequest', 'model/StripeAccountResponse', 'model/StripeCustomerEventRequest', 'model/StripeCustomerRequest', 'model/StripeCustomerResponse', 'model/StripeSubscriptionEventRequest', 'model/StripeSubscriptionRequest', 'model/StripeSubscriptionResponse', 'model/SubscriberRequest', 'model/SubscriberResponse', 'model/TopicRequest', 'model/TopicResponse', 'model/TypeformRequest', 'model/TypeformResponse', 'model/UserRequest', 'model/UserResponse', 'model/WorkItemV2Request', 'model/WorkItemV2Response', 'model/WorkV2Request', 'model/WorkV2Response'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/AttributeRequest'), require('../model/AttributeResponse'), require('../model/AttributeSetRequest'), require('../model/AttributeSetResponse'), require('../model/BuildingV2Request'), require('../model/BuildingV2Response'), require('../model/BusinessRequest'), require('../model/BusinessResponse'), require('../model/CatalogueRequest'), require('../model/CatalogueResponse'), require('../model/CategoryRequest'), require('../model/CategoryResponse'), require('../model/ConfigurationRequest'), require('../model/ConfigurationResponse'), require('../model/DeliveryItemV2Request'), require('../model/DeliveryItemV2Response'), require('../model/DeliveryV2Request'), require('../model/DeliveryV2Response'), require('../model/FlowItemRequest'), require('../model/FlowItemResponse'), require('../model/FlowRequest'), require('../model/FlowResponse'), require('../model/GoogleChartOptionsRequest'), require('../model/GoogleChartOptionsResponse'), require('../model/InvoiceItemV2Request'), require('../model/InvoiceItemV2Response'), require('../model/InvoiceV2Request'), require('../model/InvoiceV2Response'), require('../model/LocationV2Request'), require('../model/LocationV2Response'), require('../model/LoginRequest'), require('../model/LoginResponse'), require('../model/OrderItemV2Request'), require('../model/OrderItemV2Response'), require('../model/OrderV2Request'), require('../model/OrderV2Response'), require('../model/PartRequest'), require('../model/PartResponse'), require('../model/ProductRequest'), require('../model/ProductResponse'), require('../model/PublisherRequest'), require('../model/PublisherResponse'), require('../model/SettingsRequest'), require('../model/SettingsResponse'), require('../model/SiteV2Request'), require('../model/SiteV2Response'), require('../model/StationRequest'), require('../model/StationResponse'), require('../model/StatisticsRequest'), require('../model/StatisticsResponse'), require('../model/StripeAccountEventRequest'), require('../model/StripeAccountRequest'), require('../model/StripeAccountResponse'), require('../model/StripeCustomerEventRequest'), require('../model/StripeCustomerRequest'), require('../model/StripeCustomerResponse'), require('../model/StripeSubscriptionEventRequest'), require('../model/StripeSubscriptionRequest'), require('../model/StripeSubscriptionResponse'), require('../model/SubscriberRequest'), require('../model/SubscriberResponse'), require('../model/TopicRequest'), require('../model/TopicResponse'), require('../model/TypeformRequest'), require('../model/TypeformResponse'), require('../model/UserRequest'), require('../model/UserResponse'), require('../model/WorkItemV2Request'), require('../model/WorkItemV2Response'), require('../model/WorkV2Request'), require('../model/WorkV2Response'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.DefaultApi = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.AttributeRequest, root.BpmbuildUatDsappspotcom.AttributeResponse, root.BpmbuildUatDsappspotcom.AttributeSetRequest, root.BpmbuildUatDsappspotcom.AttributeSetResponse, root.BpmbuildUatDsappspotcom.BuildingV2Request, root.BpmbuildUatDsappspotcom.BuildingV2Response, root.BpmbuildUatDsappspotcom.BusinessRequest, root.BpmbuildUatDsappspotcom.BusinessResponse, root.BpmbuildUatDsappspotcom.CatalogueRequest, root.BpmbuildUatDsappspotcom.CatalogueResponse, root.BpmbuildUatDsappspotcom.CategoryRequest, root.BpmbuildUatDsappspotcom.CategoryResponse, root.BpmbuildUatDsappspotcom.ConfigurationRequest, root.BpmbuildUatDsappspotcom.ConfigurationResponse, root.BpmbuildUatDsappspotcom.DeliveryItemV2Request, root.BpmbuildUatDsappspotcom.DeliveryItemV2Response, root.BpmbuildUatDsappspotcom.DeliveryV2Request, root.BpmbuildUatDsappspotcom.DeliveryV2Response, root.BpmbuildUatDsappspotcom.FlowItemRequest, root.BpmbuildUatDsappspotcom.FlowItemResponse, root.BpmbuildUatDsappspotcom.FlowRequest, root.BpmbuildUatDsappspotcom.FlowResponse, root.BpmbuildUatDsappspotcom.GoogleChartOptionsRequest, root.BpmbuildUatDsappspotcom.GoogleChartOptionsResponse, root.BpmbuildUatDsappspotcom.InvoiceItemV2Request, root.BpmbuildUatDsappspotcom.InvoiceItemV2Response, root.BpmbuildUatDsappspotcom.InvoiceV2Request, root.BpmbuildUatDsappspotcom.InvoiceV2Response, root.BpmbuildUatDsappspotcom.LocationV2Request, root.BpmbuildUatDsappspotcom.LocationV2Response, root.BpmbuildUatDsappspotcom.LoginRequest, root.BpmbuildUatDsappspotcom.LoginResponse, root.BpmbuildUatDsappspotcom.OrderItemV2Request, root.BpmbuildUatDsappspotcom.OrderItemV2Response, root.BpmbuildUatDsappspotcom.OrderV2Request, root.BpmbuildUatDsappspotcom.OrderV2Response, root.BpmbuildUatDsappspotcom.PartRequest, root.BpmbuildUatDsappspotcom.PartResponse, root.BpmbuildUatDsappspotcom.ProductRequest, root.BpmbuildUatDsappspotcom.ProductResponse, root.BpmbuildUatDsappspotcom.PublisherRequest, root.BpmbuildUatDsappspotcom.PublisherResponse, root.BpmbuildUatDsappspotcom.SettingsRequest, root.BpmbuildUatDsappspotcom.SettingsResponse, root.BpmbuildUatDsappspotcom.SiteV2Request, root.BpmbuildUatDsappspotcom.SiteV2Response, root.BpmbuildUatDsappspotcom.StationRequest, root.BpmbuildUatDsappspotcom.StationResponse, root.BpmbuildUatDsappspotcom.StatisticsRequest, root.BpmbuildUatDsappspotcom.StatisticsResponse, root.BpmbuildUatDsappspotcom.StripeAccountEventRequest, root.BpmbuildUatDsappspotcom.StripeAccountRequest, root.BpmbuildUatDsappspotcom.StripeAccountResponse, root.BpmbuildUatDsappspotcom.StripeCustomerEventRequest, root.BpmbuildUatDsappspotcom.StripeCustomerRequest, root.BpmbuildUatDsappspotcom.StripeCustomerResponse, root.BpmbuildUatDsappspotcom.StripeSubscriptionEventRequest, root.BpmbuildUatDsappspotcom.StripeSubscriptionRequest, root.BpmbuildUatDsappspotcom.StripeSubscriptionResponse, root.BpmbuildUatDsappspotcom.SubscriberRequest, root.BpmbuildUatDsappspotcom.SubscriberResponse, root.BpmbuildUatDsappspotcom.TopicRequest, root.BpmbuildUatDsappspotcom.TopicResponse, root.BpmbuildUatDsappspotcom.TypeformRequest, root.BpmbuildUatDsappspotcom.TypeformResponse, root.BpmbuildUatDsappspotcom.UserRequest, root.BpmbuildUatDsappspotcom.UserResponse, root.BpmbuildUatDsappspotcom.WorkItemV2Request, root.BpmbuildUatDsappspotcom.WorkItemV2Response, root.BpmbuildUatDsappspotcom.WorkV2Request, root.BpmbuildUatDsappspotcom.WorkV2Response);
  }
}(this, function(ApiClient, AttributeRequest, AttributeResponse, AttributeSetRequest, AttributeSetResponse, BuildingV2Request, BuildingV2Response, BusinessRequest, BusinessResponse, CatalogueRequest, CatalogueResponse, CategoryRequest, CategoryResponse, ConfigurationRequest, ConfigurationResponse, DeliveryItemV2Request, DeliveryItemV2Response, DeliveryV2Request, DeliveryV2Response, FlowItemRequest, FlowItemResponse, FlowRequest, FlowResponse, GoogleChartOptionsRequest, GoogleChartOptionsResponse, InvoiceItemV2Request, InvoiceItemV2Response, InvoiceV2Request, InvoiceV2Response, LocationV2Request, LocationV2Response, LoginRequest, LoginResponse, OrderItemV2Request, OrderItemV2Response, OrderV2Request, OrderV2Response, PartRequest, PartResponse, ProductRequest, ProductResponse, PublisherRequest, PublisherResponse, SettingsRequest, SettingsResponse, SiteV2Request, SiteV2Response, StationRequest, StationResponse, StatisticsRequest, StatisticsResponse, StripeAccountEventRequest, StripeAccountRequest, StripeAccountResponse, StripeCustomerEventRequest, StripeCustomerRequest, StripeCustomerResponse, StripeSubscriptionEventRequest, StripeSubscriptionRequest, StripeSubscriptionResponse, SubscriberRequest, SubscriberResponse, TopicRequest, TopicResponse, TypeformRequest, TypeformResponse, UserRequest, UserResponse, WorkItemV2Request, WorkItemV2Response, WorkV2Request, WorkV2Response) {
  'use strict';

  /**
   * Default service.
   * @module api/DefaultApi
   * @version 1.0.0
   */

  /**
   * Constructs a new DefaultApi. 
   * @alias module:api/DefaultApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the attributeApiV1AttributeCreate operation.
     * @callback module:api/DefaultApi~attributeApiV1AttributeCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeRequest} opts.body 
     * @param {module:api/DefaultApi~attributeApiV1AttributeCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeResponse}
     */
    this.attributeApiV1AttributeCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeResponse;

      return this.apiClient.callApi(
        '/attributeApi/v1/attributeCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeApiV1AttributeDelete operation.
     * @callback module:api/DefaultApi~attributeApiV1AttributeDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeRequest} opts.body 
     * @param {module:api/DefaultApi~attributeApiV1AttributeDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeResponse}
     */
    this.attributeApiV1AttributeDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeResponse;

      return this.apiClient.callApi(
        '/attributeApi/v1/attributeDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeApiV1AttributeGetByCodeTag operation.
     * @callback module:api/DefaultApi~attributeApiV1AttributeGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeRequest} opts.body 
     * @param {module:api/DefaultApi~attributeApiV1AttributeGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeResponse}
     */
    this.attributeApiV1AttributeGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeResponse;

      return this.apiClient.callApi(
        '/attributeApi/v1/attributeGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeApiV1AttributeGetByCodeTagAndUsageType operation.
     * @callback module:api/DefaultApi~attributeApiV1AttributeGetByCodeTagAndUsageTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeRequest} opts.body 
     * @param {module:api/DefaultApi~attributeApiV1AttributeGetByCodeTagAndUsageTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeResponse}
     */
    this.attributeApiV1AttributeGetByCodeTagAndUsageType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeResponse;

      return this.apiClient.callApi(
        '/attributeApi/v1/attributeGetByCodeTagAndUsageType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeApiV1AttributeGetById operation.
     * @callback module:api/DefaultApi~attributeApiV1AttributeGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeRequest} opts.body 
     * @param {module:api/DefaultApi~attributeApiV1AttributeGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeResponse}
     */
    this.attributeApiV1AttributeGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeResponse;

      return this.apiClient.callApi(
        '/attributeApi/v1/attributeGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeApiV1AttributeUpdate operation.
     * @callback module:api/DefaultApi~attributeApiV1AttributeUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeRequest} opts.body 
     * @param {module:api/DefaultApi~attributeApiV1AttributeUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeResponse}
     */
    this.attributeApiV1AttributeUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeResponse;

      return this.apiClient.callApi(
        '/attributeApi/v1/attributeUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeSetApiV1AttributeSetCreate operation.
     * @callback module:api/DefaultApi~attributeSetApiV1AttributeSetCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeSetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeSetRequest} opts.body 
     * @param {module:api/DefaultApi~attributeSetApiV1AttributeSetCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeSetResponse}
     */
    this.attributeSetApiV1AttributeSetCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeSetResponse;

      return this.apiClient.callApi(
        '/attributeSetApi/v1/attributeSetCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeSetApiV1AttributeSetDelete operation.
     * @callback module:api/DefaultApi~attributeSetApiV1AttributeSetDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeSetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeSetRequest} opts.body 
     * @param {module:api/DefaultApi~attributeSetApiV1AttributeSetDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeSetResponse}
     */
    this.attributeSetApiV1AttributeSetDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeSetResponse;

      return this.apiClient.callApi(
        '/attributeSetApi/v1/attributeSetDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeSetApiV1AttributeSetGetByCodeTag operation.
     * @callback module:api/DefaultApi~attributeSetApiV1AttributeSetGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeSetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeSetRequest} opts.body 
     * @param {module:api/DefaultApi~attributeSetApiV1AttributeSetGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeSetResponse}
     */
    this.attributeSetApiV1AttributeSetGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeSetResponse;

      return this.apiClient.callApi(
        '/attributeSetApi/v1/attributeSetGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeSetApiV1AttributeSetGetByCodeTagAndUsageType operation.
     * @callback module:api/DefaultApi~attributeSetApiV1AttributeSetGetByCodeTagAndUsageTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeSetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeSetRequest} opts.body 
     * @param {module:api/DefaultApi~attributeSetApiV1AttributeSetGetByCodeTagAndUsageTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeSetResponse}
     */
    this.attributeSetApiV1AttributeSetGetByCodeTagAndUsageType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeSetResponse;

      return this.apiClient.callApi(
        '/attributeSetApi/v1/attributeSetGetByCodeTagAndUsageType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeSetApiV1AttributeSetGetById operation.
     * @callback module:api/DefaultApi~attributeSetApiV1AttributeSetGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeSetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeSetRequest} opts.body 
     * @param {module:api/DefaultApi~attributeSetApiV1AttributeSetGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeSetResponse}
     */
    this.attributeSetApiV1AttributeSetGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeSetResponse;

      return this.apiClient.callApi(
        '/attributeSetApi/v1/attributeSetGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the attributeSetApiV1AttributeSetUpdate operation.
     * @callback module:api/DefaultApi~attributeSetApiV1AttributeSetUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeSetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AttributeSetRequest} opts.body 
     * @param {module:api/DefaultApi~attributeSetApiV1AttributeSetUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeSetResponse}
     */
    this.attributeSetApiV1AttributeSetUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AttributeSetResponse;

      return this.apiClient.callApi(
        '/attributeSetApi/v1/attributeSetUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingCreate operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingV2Request} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingV2Response}
     */
    this.buildingApiV1BuildingCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingV2Response;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingDelete operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingV2Request} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingV2Response}
     */
    this.buildingApiV1BuildingDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingV2Response;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingGetByClientId operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingGetByClientIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingV2Request} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingGetByClientIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingV2Response}
     */
    this.buildingApiV1BuildingGetByClientId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingV2Response;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingGetByClientId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingGetByCodeTag operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingV2Request} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingV2Response}
     */
    this.buildingApiV1BuildingGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingV2Response;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingGetById operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingV2Request} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingV2Response}
     */
    this.buildingApiV1BuildingGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingV2Response;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingGetBySiteId operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingGetBySiteIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingV2Request} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingGetBySiteIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingV2Response}
     */
    this.buildingApiV1BuildingGetBySiteId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingV2Response;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingGetBySiteId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingUpdate operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingV2Request} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingV2Response}
     */
    this.buildingApiV1BuildingUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingV2Response;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinessAccountGet operation.
     * @callback module:api/DefaultApi~businessApiV1BusinessAccountGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinessAccountGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinessAccountGet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businessAccountGet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinessListByParentKeyAndType operation.
     * @callback module:api/DefaultApi~businessApiV1BusinessListByParentKeyAndTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinessListByParentKeyAndTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinessListByParentKeyAndType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businessListByParentKeyAndType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinessUpdate operation.
     * @callback module:api/DefaultApi~businessApiV1BusinessUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinessUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinessUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businessUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinesslistAll operation.
     * @callback module:api/DefaultApi~businessApiV1BusinesslistAllCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinesslistAllCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinesslistAll = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businesslistAll', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinesslistByName operation.
     * @callback module:api/DefaultApi~businessApiV1BusinesslistByNameCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinesslistByNameCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinesslistByName = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businesslistByName', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinesslistByType operation.
     * @callback module:api/DefaultApi~businessApiV1BusinesslistByTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinesslistByTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinesslistByType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businesslistByType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinesslistInTown operation.
     * @callback module:api/DefaultApi~businessApiV1BusinesslistInTownCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinesslistInTownCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinesslistInTown = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businesslistInTown', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1CloseBusinessNow operation.
     * @callback module:api/DefaultApi~businessApiV1CloseBusinessNowCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1CloseBusinessNowCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1CloseBusinessNow = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/closeBusinessNow', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1CreateBusiness operation.
     * @callback module:api/DefaultApi~businessApiV1CreateBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1CreateBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1CreateBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/createBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1CreateBusinessWithParent operation.
     * @callback module:api/DefaultApi~businessApiV1CreateBusinessWithParentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1CreateBusinessWithParentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1CreateBusinessWithParent = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/createBusinessWithParent', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1EraseBusiness operation.
     * @callback module:api/DefaultApi~businessApiV1EraseBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1EraseBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1EraseBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/eraseBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1LocationGet operation.
     * @callback module:api/DefaultApi~businessApiV1LocationGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1LocationGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1LocationGet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/locationGet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1LocationSet operation.
     * @callback module:api/DefaultApi~businessApiV1LocationSetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1LocationSetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1LocationSet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/locationSet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1OpenBusinessNow operation.
     * @callback module:api/DefaultApi~businessApiV1OpenBusinessNowCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1OpenBusinessNowCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1OpenBusinessNow = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/openBusinessNow', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1OpeningHoursGet operation.
     * @callback module:api/DefaultApi~businessApiV1OpeningHoursGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1OpeningHoursGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1OpeningHoursGet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/OpeningHoursGet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1OpeningHoursSet operation.
     * @callback module:api/DefaultApi~businessApiV1OpeningHoursSetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1OpeningHoursSetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1OpeningHoursSet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/OpeningHoursSet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the catalogueApiV1CatalogueCreate operation.
     * @callback module:api/DefaultApi~catalogueApiV1CatalogueCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CatalogueResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CatalogueRequest} opts.body 
     * @param {module:api/DefaultApi~catalogueApiV1CatalogueCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CatalogueResponse}
     */
    this.catalogueApiV1CatalogueCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CatalogueResponse;

      return this.apiClient.callApi(
        '/catalogueApi/v1/catalogueCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the catalogueApiV1CatalogueDelete operation.
     * @callback module:api/DefaultApi~catalogueApiV1CatalogueDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CatalogueResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CatalogueRequest} opts.body 
     * @param {module:api/DefaultApi~catalogueApiV1CatalogueDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CatalogueResponse}
     */
    this.catalogueApiV1CatalogueDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CatalogueResponse;

      return this.apiClient.callApi(
        '/catalogueApi/v1/catalogueDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the catalogueApiV1CatalogueGetByCodeTag operation.
     * @callback module:api/DefaultApi~catalogueApiV1CatalogueGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CatalogueResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CatalogueRequest} opts.body 
     * @param {module:api/DefaultApi~catalogueApiV1CatalogueGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CatalogueResponse}
     */
    this.catalogueApiV1CatalogueGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CatalogueResponse;

      return this.apiClient.callApi(
        '/catalogueApi/v1/catalogueGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the catalogueApiV1CatalogueGetById operation.
     * @callback module:api/DefaultApi~catalogueApiV1CatalogueGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CatalogueResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CatalogueRequest} opts.body 
     * @param {module:api/DefaultApi~catalogueApiV1CatalogueGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CatalogueResponse}
     */
    this.catalogueApiV1CatalogueGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CatalogueResponse;

      return this.apiClient.callApi(
        '/catalogueApi/v1/catalogueGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the catalogueApiV1CatalogueUpdate operation.
     * @callback module:api/DefaultApi~catalogueApiV1CatalogueUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CatalogueResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CatalogueRequest} opts.body 
     * @param {module:api/DefaultApi~catalogueApiV1CatalogueUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CatalogueResponse}
     */
    this.catalogueApiV1CatalogueUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CatalogueResponse;

      return this.apiClient.callApi(
        '/catalogueApi/v1/catalogueUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the categoryApiV1CategoryCreate operation.
     * @callback module:api/DefaultApi~categoryApiV1CategoryCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CategoryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CategoryRequest} opts.body 
     * @param {module:api/DefaultApi~categoryApiV1CategoryCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CategoryResponse}
     */
    this.categoryApiV1CategoryCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CategoryResponse;

      return this.apiClient.callApi(
        '/categoryApi/v1/categoryCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the categoryApiV1CategoryDelete operation.
     * @callback module:api/DefaultApi~categoryApiV1CategoryDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CategoryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CategoryRequest} opts.body 
     * @param {module:api/DefaultApi~categoryApiV1CategoryDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CategoryResponse}
     */
    this.categoryApiV1CategoryDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CategoryResponse;

      return this.apiClient.callApi(
        '/categoryApi/v1/categoryDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the categoryApiV1CategoryGetByCatalogueId operation.
     * @callback module:api/DefaultApi~categoryApiV1CategoryGetByCatalogueIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CategoryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CategoryRequest} opts.body 
     * @param {module:api/DefaultApi~categoryApiV1CategoryGetByCatalogueIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CategoryResponse}
     */
    this.categoryApiV1CategoryGetByCatalogueId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CategoryResponse;

      return this.apiClient.callApi(
        '/categoryApi/v1/categoryGetByCatalogueId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the categoryApiV1CategoryGetByCodeTag operation.
     * @callback module:api/DefaultApi~categoryApiV1CategoryGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CategoryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CategoryRequest} opts.body 
     * @param {module:api/DefaultApi~categoryApiV1CategoryGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CategoryResponse}
     */
    this.categoryApiV1CategoryGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CategoryResponse;

      return this.apiClient.callApi(
        '/categoryApi/v1/categoryGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the categoryApiV1CategoryGetById operation.
     * @callback module:api/DefaultApi~categoryApiV1CategoryGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CategoryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CategoryRequest} opts.body 
     * @param {module:api/DefaultApi~categoryApiV1CategoryGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CategoryResponse}
     */
    this.categoryApiV1CategoryGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CategoryResponse;

      return this.apiClient.callApi(
        '/categoryApi/v1/categoryGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the categoryApiV1CategoryUpdate operation.
     * @callback module:api/DefaultApi~categoryApiV1CategoryUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CategoryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CategoryRequest} opts.body 
     * @param {module:api/DefaultApi~categoryApiV1CategoryUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CategoryResponse}
     */
    this.categoryApiV1CategoryUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CategoryResponse;

      return this.apiClient.callApi(
        '/categoryApi/v1/categoryUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ConfigUpdateBoolean operation.
     * @callback module:api/DefaultApi~configurationApiV1ConfigUpdateBooleanCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ConfigUpdateBooleanCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ConfigUpdateBoolean = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/configUpdateBoolean', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ConfigUpdateInt operation.
     * @callback module:api/DefaultApi~configurationApiV1ConfigUpdateIntCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ConfigUpdateIntCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ConfigUpdateInt = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/configUpdateInt', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ConfigUpdateString operation.
     * @callback module:api/DefaultApi~configurationApiV1ConfigUpdateStringCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ConfigUpdateStringCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ConfigUpdateString = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/configUpdateString', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1DumpConfig operation.
     * @callback module:api/DefaultApi~configurationApiV1DumpConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1DumpConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1DumpConfig = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/dumpConfig', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ReloadConfig operation.
     * @callback module:api/DefaultApi~configurationApiV1ReloadConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ReloadConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ReloadConfig = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/reloadConfig', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1StoreConfig operation.
     * @callback module:api/DefaultApi~configurationApiV1StoreConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1StoreConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1StoreConfig = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/storeConfig', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deliveryApiV1DeliveryCreate operation.
     * @callback module:api/DefaultApi~deliveryApiV1DeliveryCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeliveryV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DeliveryV2Request} opts.body 
     * @param {module:api/DefaultApi~deliveryApiV1DeliveryCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeliveryV2Response}
     */
    this.deliveryApiV1DeliveryCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DeliveryV2Response;

      return this.apiClient.callApi(
        '/deliveryApi/v1/deliveryCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deliveryApiV1DeliveryDelete operation.
     * @callback module:api/DefaultApi~deliveryApiV1DeliveryDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeliveryV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DeliveryV2Request} opts.body 
     * @param {module:api/DefaultApi~deliveryApiV1DeliveryDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeliveryV2Response}
     */
    this.deliveryApiV1DeliveryDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DeliveryV2Response;

      return this.apiClient.callApi(
        '/deliveryApi/v1/deliveryDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deliveryApiV1DeliveryGetByCodeTag operation.
     * @callback module:api/DefaultApi~deliveryApiV1DeliveryGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeliveryV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DeliveryV2Request} opts.body 
     * @param {module:api/DefaultApi~deliveryApiV1DeliveryGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeliveryV2Response}
     */
    this.deliveryApiV1DeliveryGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DeliveryV2Response;

      return this.apiClient.callApi(
        '/deliveryApi/v1/deliveryGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deliveryApiV1DeliveryGetById operation.
     * @callback module:api/DefaultApi~deliveryApiV1DeliveryGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeliveryV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DeliveryV2Request} opts.body 
     * @param {module:api/DefaultApi~deliveryApiV1DeliveryGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeliveryV2Response}
     */
    this.deliveryApiV1DeliveryGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DeliveryV2Response;

      return this.apiClient.callApi(
        '/deliveryApi/v1/deliveryGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deliveryApiV1DeliveryUpdate operation.
     * @callback module:api/DefaultApi~deliveryApiV1DeliveryUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeliveryV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DeliveryV2Request} opts.body 
     * @param {module:api/DefaultApi~deliveryApiV1DeliveryUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeliveryV2Response}
     */
    this.deliveryApiV1DeliveryUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DeliveryV2Response;

      return this.apiClient.callApi(
        '/deliveryApi/v1/deliveryUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deliveryItemApiV1DeliveryItemCreate operation.
     * @callback module:api/DefaultApi~deliveryItemApiV1DeliveryItemCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeliveryItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DeliveryItemV2Request} opts.body 
     * @param {module:api/DefaultApi~deliveryItemApiV1DeliveryItemCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeliveryItemV2Response}
     */
    this.deliveryItemApiV1DeliveryItemCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DeliveryItemV2Response;

      return this.apiClient.callApi(
        '/deliveryItemApi/v1/deliveryItemCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deliveryItemApiV1DeliveryItemDelete operation.
     * @callback module:api/DefaultApi~deliveryItemApiV1DeliveryItemDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeliveryItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DeliveryItemV2Request} opts.body 
     * @param {module:api/DefaultApi~deliveryItemApiV1DeliveryItemDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeliveryItemV2Response}
     */
    this.deliveryItemApiV1DeliveryItemDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DeliveryItemV2Response;

      return this.apiClient.callApi(
        '/deliveryItemApi/v1/deliveryItemDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deliveryItemApiV1DeliveryItemGetById operation.
     * @callback module:api/DefaultApi~deliveryItemApiV1DeliveryItemGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeliveryItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DeliveryItemV2Request} opts.body 
     * @param {module:api/DefaultApi~deliveryItemApiV1DeliveryItemGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeliveryItemV2Response}
     */
    this.deliveryItemApiV1DeliveryItemGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DeliveryItemV2Response;

      return this.apiClient.callApi(
        '/deliveryItemApi/v1/deliveryItemGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deliveryItemApiV1DeliveryItemUpdate operation.
     * @callback module:api/DefaultApi~deliveryItemApiV1DeliveryItemUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeliveryItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DeliveryItemV2Request} opts.body 
     * @param {module:api/DefaultApi~deliveryItemApiV1DeliveryItemUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeliveryItemV2Response}
     */
    this.deliveryItemApiV1DeliveryItemUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DeliveryItemV2Response;

      return this.apiClient.callApi(
        '/deliveryItemApi/v1/deliveryItemUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowApiV1FlowCreate operation.
     * @callback module:api/DefaultApi~flowApiV1FlowCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowRequest} opts.body 
     * @param {module:api/DefaultApi~flowApiV1FlowCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowResponse}
     */
    this.flowApiV1FlowCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowResponse;

      return this.apiClient.callApi(
        '/flowApi/v1/flowCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowApiV1FlowDelete operation.
     * @callback module:api/DefaultApi~flowApiV1FlowDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowRequest} opts.body 
     * @param {module:api/DefaultApi~flowApiV1FlowDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowResponse}
     */
    this.flowApiV1FlowDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowResponse;

      return this.apiClient.callApi(
        '/flowApi/v1/flowDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowApiV1FlowGetByCodeTag operation.
     * @callback module:api/DefaultApi~flowApiV1FlowGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowRequest} opts.body 
     * @param {module:api/DefaultApi~flowApiV1FlowGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowResponse}
     */
    this.flowApiV1FlowGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowResponse;

      return this.apiClient.callApi(
        '/flowApi/v1/flowGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowApiV1FlowGetById operation.
     * @callback module:api/DefaultApi~flowApiV1FlowGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowRequest} opts.body 
     * @param {module:api/DefaultApi~flowApiV1FlowGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowResponse}
     */
    this.flowApiV1FlowGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowResponse;

      return this.apiClient.callApi(
        '/flowApi/v1/flowGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowApiV1FlowUpdate operation.
     * @callback module:api/DefaultApi~flowApiV1FlowUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowRequest} opts.body 
     * @param {module:api/DefaultApi~flowApiV1FlowUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowResponse}
     */
    this.flowApiV1FlowUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowResponse;

      return this.apiClient.callApi(
        '/flowApi/v1/flowUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowItemApiV1FlowItemCreate operation.
     * @callback module:api/DefaultApi~flowItemApiV1FlowItemCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowItemRequest} opts.body 
     * @param {module:api/DefaultApi~flowItemApiV1FlowItemCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowItemResponse}
     */
    this.flowItemApiV1FlowItemCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowItemResponse;

      return this.apiClient.callApi(
        '/flowItemApi/v1/flowItemCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowItemApiV1FlowItemDelete operation.
     * @callback module:api/DefaultApi~flowItemApiV1FlowItemDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowItemRequest} opts.body 
     * @param {module:api/DefaultApi~flowItemApiV1FlowItemDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowItemResponse}
     */
    this.flowItemApiV1FlowItemDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowItemResponse;

      return this.apiClient.callApi(
        '/flowItemApi/v1/flowItemDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowItemApiV1FlowItemGetByCodeTag operation.
     * @callback module:api/DefaultApi~flowItemApiV1FlowItemGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowItemRequest} opts.body 
     * @param {module:api/DefaultApi~flowItemApiV1FlowItemGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowItemResponse}
     */
    this.flowItemApiV1FlowItemGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowItemResponse;

      return this.apiClient.callApi(
        '/flowItemApi/v1/flowItemGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowItemApiV1FlowItemGetById operation.
     * @callback module:api/DefaultApi~flowItemApiV1FlowItemGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowItemRequest} opts.body 
     * @param {module:api/DefaultApi~flowItemApiV1FlowItemGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowItemResponse}
     */
    this.flowItemApiV1FlowItemGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowItemResponse;

      return this.apiClient.callApi(
        '/flowItemApi/v1/flowItemGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowItemApiV1FlowItemGetByToolId operation.
     * @callback module:api/DefaultApi~flowItemApiV1FlowItemGetByToolIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowItemRequest} opts.body 
     * @param {module:api/DefaultApi~flowItemApiV1FlowItemGetByToolIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowItemResponse}
     */
    this.flowItemApiV1FlowItemGetByToolId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowItemResponse;

      return this.apiClient.callApi(
        '/flowItemApi/v1/flowItemGetByToolId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the flowItemApiV1FlowItemUpdate operation.
     * @callback module:api/DefaultApi~flowItemApiV1FlowItemUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FlowItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/FlowItemRequest} opts.body 
     * @param {module:api/DefaultApi~flowItemApiV1FlowItemUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FlowItemResponse}
     */
    this.flowItemApiV1FlowItemUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = FlowItemResponse;

      return this.apiClient.callApi(
        '/flowItemApi/v1/flowItemUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the googleChartOptionsApiV1GoogleChartOptionsCreate operation.
     * @callback module:api/DefaultApi~googleChartOptionsApiV1GoogleChartOptionsCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GoogleChartOptionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/GoogleChartOptionsRequest} opts.body 
     * @param {module:api/DefaultApi~googleChartOptionsApiV1GoogleChartOptionsCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GoogleChartOptionsResponse}
     */
    this.googleChartOptionsApiV1GoogleChartOptionsCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = GoogleChartOptionsResponse;

      return this.apiClient.callApi(
        '/googleChartOptionsApi/v1/googleChartOptionsCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the googleChartOptionsApiV1GoogleChartOptionsDelete operation.
     * @callback module:api/DefaultApi~googleChartOptionsApiV1GoogleChartOptionsDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GoogleChartOptionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/GoogleChartOptionsRequest} opts.body 
     * @param {module:api/DefaultApi~googleChartOptionsApiV1GoogleChartOptionsDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GoogleChartOptionsResponse}
     */
    this.googleChartOptionsApiV1GoogleChartOptionsDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = GoogleChartOptionsResponse;

      return this.apiClient.callApi(
        '/googleChartOptionsApi/v1/googleChartOptionsDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the googleChartOptionsApiV1GoogleChartOptionsGetByCodeTag operation.
     * @callback module:api/DefaultApi~googleChartOptionsApiV1GoogleChartOptionsGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GoogleChartOptionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/GoogleChartOptionsRequest} opts.body 
     * @param {module:api/DefaultApi~googleChartOptionsApiV1GoogleChartOptionsGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GoogleChartOptionsResponse}
     */
    this.googleChartOptionsApiV1GoogleChartOptionsGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = GoogleChartOptionsResponse;

      return this.apiClient.callApi(
        '/googleChartOptionsApi/v1/googleChartOptionsGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the googleChartOptionsApiV1GoogleChartOptionsGetById operation.
     * @callback module:api/DefaultApi~googleChartOptionsApiV1GoogleChartOptionsGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GoogleChartOptionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/GoogleChartOptionsRequest} opts.body 
     * @param {module:api/DefaultApi~googleChartOptionsApiV1GoogleChartOptionsGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GoogleChartOptionsResponse}
     */
    this.googleChartOptionsApiV1GoogleChartOptionsGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = GoogleChartOptionsResponse;

      return this.apiClient.callApi(
        '/googleChartOptionsApi/v1/googleChartOptionsGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the googleChartOptionsApiV1GoogleChartOptionsUpdate operation.
     * @callback module:api/DefaultApi~googleChartOptionsApiV1GoogleChartOptionsUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GoogleChartOptionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/GoogleChartOptionsRequest} opts.body 
     * @param {module:api/DefaultApi~googleChartOptionsApiV1GoogleChartOptionsUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GoogleChartOptionsResponse}
     */
    this.googleChartOptionsApiV1GoogleChartOptionsUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = GoogleChartOptionsResponse;

      return this.apiClient.callApi(
        '/googleChartOptionsApi/v1/googleChartOptionsUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the invoiceApiV1InvoiceCreate operation.
     * @callback module:api/DefaultApi~invoiceApiV1InvoiceCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvoiceV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InvoiceV2Request} opts.body 
     * @param {module:api/DefaultApi~invoiceApiV1InvoiceCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvoiceV2Response}
     */
    this.invoiceApiV1InvoiceCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = InvoiceV2Response;

      return this.apiClient.callApi(
        '/invoiceApi/v1/invoiceCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the invoiceApiV1InvoiceDelete operation.
     * @callback module:api/DefaultApi~invoiceApiV1InvoiceDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvoiceV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InvoiceV2Request} opts.body 
     * @param {module:api/DefaultApi~invoiceApiV1InvoiceDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvoiceV2Response}
     */
    this.invoiceApiV1InvoiceDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = InvoiceV2Response;

      return this.apiClient.callApi(
        '/invoiceApi/v1/invoiceDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the invoiceApiV1InvoiceGetByCodeTag operation.
     * @callback module:api/DefaultApi~invoiceApiV1InvoiceGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvoiceV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InvoiceV2Request} opts.body 
     * @param {module:api/DefaultApi~invoiceApiV1InvoiceGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvoiceV2Response}
     */
    this.invoiceApiV1InvoiceGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = InvoiceV2Response;

      return this.apiClient.callApi(
        '/invoiceApi/v1/invoiceGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the invoiceApiV1InvoiceGetById operation.
     * @callback module:api/DefaultApi~invoiceApiV1InvoiceGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvoiceV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InvoiceV2Request} opts.body 
     * @param {module:api/DefaultApi~invoiceApiV1InvoiceGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvoiceV2Response}
     */
    this.invoiceApiV1InvoiceGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = InvoiceV2Response;

      return this.apiClient.callApi(
        '/invoiceApi/v1/invoiceGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the invoiceApiV1InvoiceUpdate operation.
     * @callback module:api/DefaultApi~invoiceApiV1InvoiceUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvoiceV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InvoiceV2Request} opts.body 
     * @param {module:api/DefaultApi~invoiceApiV1InvoiceUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvoiceV2Response}
     */
    this.invoiceApiV1InvoiceUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = InvoiceV2Response;

      return this.apiClient.callApi(
        '/invoiceApi/v1/invoiceUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the invoiceItemApiV1InvoiceItemCreate operation.
     * @callback module:api/DefaultApi~invoiceItemApiV1InvoiceItemCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvoiceItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InvoiceItemV2Request} opts.body 
     * @param {module:api/DefaultApi~invoiceItemApiV1InvoiceItemCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvoiceItemV2Response}
     */
    this.invoiceItemApiV1InvoiceItemCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = InvoiceItemV2Response;

      return this.apiClient.callApi(
        '/invoiceItemApi/v1/invoiceItemCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the invoiceItemApiV1InvoiceItemDelete operation.
     * @callback module:api/DefaultApi~invoiceItemApiV1InvoiceItemDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvoiceItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InvoiceItemV2Request} opts.body 
     * @param {module:api/DefaultApi~invoiceItemApiV1InvoiceItemDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvoiceItemV2Response}
     */
    this.invoiceItemApiV1InvoiceItemDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = InvoiceItemV2Response;

      return this.apiClient.callApi(
        '/invoiceItemApi/v1/invoiceItemDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the invoiceItemApiV1InvoiceItemUpdate operation.
     * @callback module:api/DefaultApi~invoiceItemApiV1InvoiceItemUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvoiceItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InvoiceItemV2Request} opts.body 
     * @param {module:api/DefaultApi~invoiceItemApiV1InvoiceItemUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvoiceItemV2Response}
     */
    this.invoiceItemApiV1InvoiceItemUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = InvoiceItemV2Response;

      return this.apiClient.callApi(
        '/invoiceItemApi/v1/invoiceItemUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the locationApiV1LocationV2Create operation.
     * @callback module:api/DefaultApi~locationApiV1LocationV2CreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocationV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LocationV2Request} opts.body 
     * @param {module:api/DefaultApi~locationApiV1LocationV2CreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LocationV2Response}
     */
    this.locationApiV1LocationV2Create = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LocationV2Response;

      return this.apiClient.callApi(
        '/locationApi/v1/locationV2Create', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the locationApiV1LocationV2Delete operation.
     * @callback module:api/DefaultApi~locationApiV1LocationV2DeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocationV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LocationV2Request} opts.body 
     * @param {module:api/DefaultApi~locationApiV1LocationV2DeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LocationV2Response}
     */
    this.locationApiV1LocationV2Delete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LocationV2Response;

      return this.apiClient.callApi(
        '/locationApi/v1/locationV2Delete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the locationApiV1LocationV2GetByBuildingId operation.
     * @callback module:api/DefaultApi~locationApiV1LocationV2GetByBuildingIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocationV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LocationV2Request} opts.body 
     * @param {module:api/DefaultApi~locationApiV1LocationV2GetByBuildingIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LocationV2Response}
     */
    this.locationApiV1LocationV2GetByBuildingId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LocationV2Response;

      return this.apiClient.callApi(
        '/locationApi/v1/locationV2GetByBuildingId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the locationApiV1LocationV2GetByClientId operation.
     * @callback module:api/DefaultApi~locationApiV1LocationV2GetByClientIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocationV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LocationV2Request} opts.body 
     * @param {module:api/DefaultApi~locationApiV1LocationV2GetByClientIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LocationV2Response}
     */
    this.locationApiV1LocationV2GetByClientId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LocationV2Response;

      return this.apiClient.callApi(
        '/locationApi/v1/locationV2GetByClientId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the locationApiV1LocationV2GetByCodeTag operation.
     * @callback module:api/DefaultApi~locationApiV1LocationV2GetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocationV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LocationV2Request} opts.body 
     * @param {module:api/DefaultApi~locationApiV1LocationV2GetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LocationV2Response}
     */
    this.locationApiV1LocationV2GetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LocationV2Response;

      return this.apiClient.callApi(
        '/locationApi/v1/locationV2GetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the locationApiV1LocationV2GetByCustomerId operation.
     * @callback module:api/DefaultApi~locationApiV1LocationV2GetByCustomerIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocationV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LocationV2Request} opts.body 
     * @param {module:api/DefaultApi~locationApiV1LocationV2GetByCustomerIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LocationV2Response}
     */
    this.locationApiV1LocationV2GetByCustomerId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LocationV2Response;

      return this.apiClient.callApi(
        '/locationApi/v1/locationV2GetByCustomerId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the locationApiV1LocationV2GetById operation.
     * @callback module:api/DefaultApi~locationApiV1LocationV2GetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocationV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LocationV2Request} opts.body 
     * @param {module:api/DefaultApi~locationApiV1LocationV2GetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LocationV2Response}
     */
    this.locationApiV1LocationV2GetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LocationV2Response;

      return this.apiClient.callApi(
        '/locationApi/v1/locationV2GetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the locationApiV1LocationV2Update operation.
     * @callback module:api/DefaultApi~locationApiV1LocationV2UpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LocationV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LocationV2Request} opts.body 
     * @param {module:api/DefaultApi~locationApiV1LocationV2UpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LocationV2Response}
     */
    this.locationApiV1LocationV2Update = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LocationV2Response;

      return this.apiClient.callApi(
        '/locationApi/v1/locationV2Update', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the loginApiV1Login operation.
     * @callback module:api/DefaultApi~loginApiV1LoginCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LoginResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LoginRequest} opts.body 
     * @param {module:api/DefaultApi~loginApiV1LoginCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LoginResponse}
     */
    this.loginApiV1Login = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LoginResponse;

      return this.apiClient.callApi(
        '/loginApi/v1/login', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the loginApiV1LoginByType operation.
     * @callback module:api/DefaultApi~loginApiV1LoginByTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LoginResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LoginRequest} opts.body 
     * @param {module:api/DefaultApi~loginApiV1LoginByTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LoginResponse}
     */
    this.loginApiV1LoginByType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LoginResponse;

      return this.apiClient.callApi(
        '/loginApi/v1/loginByType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the loginApiV1LoginListBusinesses operation.
     * @callback module:api/DefaultApi~loginApiV1LoginListBusinessesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LoginResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LoginRequest} opts.body 
     * @param {module:api/DefaultApi~loginApiV1LoginListBusinessesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LoginResponse}
     */
    this.loginApiV1LoginListBusinesses = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LoginResponse;

      return this.apiClient.callApi(
        '/loginApi/v1/loginListBusinesses', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderApiV1OrderCreate operation.
     * @callback module:api/DefaultApi~orderApiV1OrderCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderV2Request} opts.body 
     * @param {module:api/DefaultApi~orderApiV1OrderCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderV2Response}
     */
    this.orderApiV1OrderCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderV2Response;

      return this.apiClient.callApi(
        '/orderApi/v1/orderCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderApiV1OrderDelete operation.
     * @callback module:api/DefaultApi~orderApiV1OrderDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderV2Request} opts.body 
     * @param {module:api/DefaultApi~orderApiV1OrderDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderV2Response}
     */
    this.orderApiV1OrderDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderV2Response;

      return this.apiClient.callApi(
        '/orderApi/v1/orderDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderApiV1OrderGetByClientId operation.
     * @callback module:api/DefaultApi~orderApiV1OrderGetByClientIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderV2Request} opts.body 
     * @param {module:api/DefaultApi~orderApiV1OrderGetByClientIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderV2Response}
     */
    this.orderApiV1OrderGetByClientId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderV2Response;

      return this.apiClient.callApi(
        '/orderApi/v1/orderGetByClientId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderApiV1OrderGetByClientIdAndStatus operation.
     * @callback module:api/DefaultApi~orderApiV1OrderGetByClientIdAndStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderV2Request} opts.body 
     * @param {module:api/DefaultApi~orderApiV1OrderGetByClientIdAndStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderV2Response}
     */
    this.orderApiV1OrderGetByClientIdAndStatus = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderV2Response;

      return this.apiClient.callApi(
        '/orderApi/v1/orderGetByClientIdAndStatus', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderApiV1OrderGetByClientReferenceNumber operation.
     * @callback module:api/DefaultApi~orderApiV1OrderGetByClientReferenceNumberCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderV2Request} opts.body 
     * @param {module:api/DefaultApi~orderApiV1OrderGetByClientReferenceNumberCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderV2Response}
     */
    this.orderApiV1OrderGetByClientReferenceNumber = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderV2Response;

      return this.apiClient.callApi(
        '/orderApi/v1/orderGetByClientReferenceNumber', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderApiV1OrderGetByCodeTag operation.
     * @callback module:api/DefaultApi~orderApiV1OrderGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderV2Request} opts.body 
     * @param {module:api/DefaultApi~orderApiV1OrderGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderV2Response}
     */
    this.orderApiV1OrderGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderV2Response;

      return this.apiClient.callApi(
        '/orderApi/v1/orderGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderApiV1OrderGetById operation.
     * @callback module:api/DefaultApi~orderApiV1OrderGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderV2Request} opts.body 
     * @param {module:api/DefaultApi~orderApiV1OrderGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderV2Response}
     */
    this.orderApiV1OrderGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderV2Response;

      return this.apiClient.callApi(
        '/orderApi/v1/orderGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderApiV1OrderGetByStatus operation.
     * @callback module:api/DefaultApi~orderApiV1OrderGetByStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderV2Request} opts.body 
     * @param {module:api/DefaultApi~orderApiV1OrderGetByStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderV2Response}
     */
    this.orderApiV1OrderGetByStatus = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderV2Response;

      return this.apiClient.callApi(
        '/orderApi/v1/orderGetByStatus', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderApiV1OrderUpdate operation.
     * @callback module:api/DefaultApi~orderApiV1OrderUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderV2Request} opts.body 
     * @param {module:api/DefaultApi~orderApiV1OrderUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderV2Response}
     */
    this.orderApiV1OrderUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderV2Response;

      return this.apiClient.callApi(
        '/orderApi/v1/orderUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderItemApiV1OrderItemCreate operation.
     * @callback module:api/DefaultApi~orderItemApiV1OrderItemCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderItemV2Request} opts.body 
     * @param {module:api/DefaultApi~orderItemApiV1OrderItemCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderItemV2Response}
     */
    this.orderItemApiV1OrderItemCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderItemV2Response;

      return this.apiClient.callApi(
        '/orderItemApi/v1/orderItemCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderItemApiV1OrderItemDelete operation.
     * @callback module:api/DefaultApi~orderItemApiV1OrderItemDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderItemV2Request} opts.body 
     * @param {module:api/DefaultApi~orderItemApiV1OrderItemDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderItemV2Response}
     */
    this.orderItemApiV1OrderItemDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderItemV2Response;

      return this.apiClient.callApi(
        '/orderItemApi/v1/orderItemDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderItemApiV1OrderItemGetByOrderId operation.
     * @callback module:api/DefaultApi~orderItemApiV1OrderItemGetByOrderIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderItemV2Request} opts.body 
     * @param {module:api/DefaultApi~orderItemApiV1OrderItemGetByOrderIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderItemV2Response}
     */
    this.orderItemApiV1OrderItemGetByOrderId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderItemV2Response;

      return this.apiClient.callApi(
        '/orderItemApi/v1/orderItemGetByOrderId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the orderItemApiV1OrderItemUpdate operation.
     * @callback module:api/DefaultApi~orderItemApiV1OrderItemUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/OrderItemV2Request} opts.body 
     * @param {module:api/DefaultApi~orderItemApiV1OrderItemUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderItemV2Response}
     */
    this.orderItemApiV1OrderItemUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = OrderItemV2Response;

      return this.apiClient.callApi(
        '/orderItemApi/v1/orderItemUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the partApiV1PartCreate operation.
     * @callback module:api/DefaultApi~partApiV1PartCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PartResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartRequest} opts.body 
     * @param {module:api/DefaultApi~partApiV1PartCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PartResponse}
     */
    this.partApiV1PartCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PartResponse;

      return this.apiClient.callApi(
        '/partApi/v1/partCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the partApiV1PartDelete operation.
     * @callback module:api/DefaultApi~partApiV1PartDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PartResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartRequest} opts.body 
     * @param {module:api/DefaultApi~partApiV1PartDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PartResponse}
     */
    this.partApiV1PartDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PartResponse;

      return this.apiClient.callApi(
        '/partApi/v1/partDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the partApiV1PartGetByCodeTag operation.
     * @callback module:api/DefaultApi~partApiV1PartGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PartResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartRequest} opts.body 
     * @param {module:api/DefaultApi~partApiV1PartGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PartResponse}
     */
    this.partApiV1PartGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PartResponse;

      return this.apiClient.callApi(
        '/partApi/v1/partGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the partApiV1PartGetById operation.
     * @callback module:api/DefaultApi~partApiV1PartGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PartResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartRequest} opts.body 
     * @param {module:api/DefaultApi~partApiV1PartGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PartResponse}
     */
    this.partApiV1PartGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PartResponse;

      return this.apiClient.callApi(
        '/partApi/v1/partGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the partApiV1PartGetByIdAndFlow operation.
     * @callback module:api/DefaultApi~partApiV1PartGetByIdAndFlowCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PartResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartRequest} opts.body 
     * @param {module:api/DefaultApi~partApiV1PartGetByIdAndFlowCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PartResponse}
     */
    this.partApiV1PartGetByIdAndFlow = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PartResponse;

      return this.apiClient.callApi(
        '/partApi/v1/partGetByIdAndFlow', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the partApiV1PartUpdate operation.
     * @callback module:api/DefaultApi~partApiV1PartUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PartResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartRequest} opts.body 
     * @param {module:api/DefaultApi~partApiV1PartUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PartResponse}
     */
    this.partApiV1PartUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PartResponse;

      return this.apiClient.callApi(
        '/partApi/v1/partUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductCreate operation.
     * @callback module:api/DefaultApi~productApiV1ProductCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductDelete operation.
     * @callback module:api/DefaultApi~productApiV1ProductDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductGetByCodeTag operation.
     * @callback module:api/DefaultApi~productApiV1ProductGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductGetById operation.
     * @callback module:api/DefaultApi~productApiV1ProductGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductGetByIdAndFlow operation.
     * @callback module:api/DefaultApi~productApiV1ProductGetByIdAndFlowCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductGetByIdAndFlowCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductGetByIdAndFlow = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productGetByIdAndFlow', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the productApiV1ProductUpdate operation.
     * @callback module:api/DefaultApi~productApiV1ProductUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ProductRequest} opts.body 
     * @param {module:api/DefaultApi~productApiV1ProductUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductResponse}
     */
    this.productApiV1ProductUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ProductResponse;

      return this.apiClient.callApi(
        '/productApi/v1/productUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publisherApiV1PublisherCreate operation.
     * @callback module:api/DefaultApi~publisherApiV1PublisherCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PublisherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PublisherRequest} opts.body 
     * @param {module:api/DefaultApi~publisherApiV1PublisherCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PublisherResponse}
     */
    this.publisherApiV1PublisherCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PublisherResponse;

      return this.apiClient.callApi(
        '/publisherApi/v1/publisherCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publisherApiV1PublisherDelete operation.
     * @callback module:api/DefaultApi~publisherApiV1PublisherDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PublisherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PublisherRequest} opts.body 
     * @param {module:api/DefaultApi~publisherApiV1PublisherDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PublisherResponse}
     */
    this.publisherApiV1PublisherDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PublisherResponse;

      return this.apiClient.callApi(
        '/publisherApi/v1/publisherDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publisherApiV1PublisherGetByCodeTag operation.
     * @callback module:api/DefaultApi~publisherApiV1PublisherGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PublisherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PublisherRequest} opts.body 
     * @param {module:api/DefaultApi~publisherApiV1PublisherGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PublisherResponse}
     */
    this.publisherApiV1PublisherGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PublisherResponse;

      return this.apiClient.callApi(
        '/publisherApi/v1/publisherGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publisherApiV1PublisherGetById operation.
     * @callback module:api/DefaultApi~publisherApiV1PublisherGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PublisherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PublisherRequest} opts.body 
     * @param {module:api/DefaultApi~publisherApiV1PublisherGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PublisherResponse}
     */
    this.publisherApiV1PublisherGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PublisherResponse;

      return this.apiClient.callApi(
        '/publisherApi/v1/publisherGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publisherApiV1PublisherUpdate operation.
     * @callback module:api/DefaultApi~publisherApiV1PublisherUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PublisherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PublisherRequest} opts.body 
     * @param {module:api/DefaultApi~publisherApiV1PublisherUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PublisherResponse}
     */
    this.publisherApiV1PublisherUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PublisherResponse;

      return this.apiClient.callApi(
        '/publisherApi/v1/publisherUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the settingsApiV1SettingsCreate operation.
     * @callback module:api/DefaultApi~settingsApiV1SettingsCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettingsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SettingsRequest} opts.body 
     * @param {module:api/DefaultApi~settingsApiV1SettingsCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SettingsResponse}
     */
    this.settingsApiV1SettingsCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SettingsResponse;

      return this.apiClient.callApi(
        '/settingsApi/v1/settingsCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the settingsApiV1SettingsDelete operation.
     * @callback module:api/DefaultApi~settingsApiV1SettingsDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettingsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SettingsRequest} opts.body 
     * @param {module:api/DefaultApi~settingsApiV1SettingsDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SettingsResponse}
     */
    this.settingsApiV1SettingsDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SettingsResponse;

      return this.apiClient.callApi(
        '/settingsApi/v1/settingsDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the settingsApiV1SettingsGetByCodeTag operation.
     * @callback module:api/DefaultApi~settingsApiV1SettingsGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettingsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SettingsRequest} opts.body 
     * @param {module:api/DefaultApi~settingsApiV1SettingsGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SettingsResponse}
     */
    this.settingsApiV1SettingsGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SettingsResponse;

      return this.apiClient.callApi(
        '/settingsApi/v1/settingsGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the settingsApiV1SettingsGetById operation.
     * @callback module:api/DefaultApi~settingsApiV1SettingsGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettingsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SettingsRequest} opts.body 
     * @param {module:api/DefaultApi~settingsApiV1SettingsGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SettingsResponse}
     */
    this.settingsApiV1SettingsGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SettingsResponse;

      return this.apiClient.callApi(
        '/settingsApi/v1/settingsGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the settingsApiV1SettingsGetByPage operation.
     * @callback module:api/DefaultApi~settingsApiV1SettingsGetByPageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettingsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SettingsRequest} opts.body 
     * @param {module:api/DefaultApi~settingsApiV1SettingsGetByPageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SettingsResponse}
     */
    this.settingsApiV1SettingsGetByPage = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SettingsResponse;

      return this.apiClient.callApi(
        '/settingsApi/v1/settingsGetByPage', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the settingsApiV1SettingsUpdate operation.
     * @callback module:api/DefaultApi~settingsApiV1SettingsUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettingsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SettingsRequest} opts.body 
     * @param {module:api/DefaultApi~settingsApiV1SettingsUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SettingsResponse}
     */
    this.settingsApiV1SettingsUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SettingsResponse;

      return this.apiClient.callApi(
        '/settingsApi/v1/settingsUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the siteApiV1SiteCreate operation.
     * @callback module:api/DefaultApi~siteApiV1SiteCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SiteV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SiteV2Request} opts.body 
     * @param {module:api/DefaultApi~siteApiV1SiteCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SiteV2Response}
     */
    this.siteApiV1SiteCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SiteV2Response;

      return this.apiClient.callApi(
        '/siteApi/v1/siteCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the siteApiV1SiteDelete operation.
     * @callback module:api/DefaultApi~siteApiV1SiteDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SiteV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SiteV2Request} opts.body 
     * @param {module:api/DefaultApi~siteApiV1SiteDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SiteV2Response}
     */
    this.siteApiV1SiteDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SiteV2Response;

      return this.apiClient.callApi(
        '/siteApi/v1/siteDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the siteApiV1SiteGetByClientId operation.
     * @callback module:api/DefaultApi~siteApiV1SiteGetByClientIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SiteV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SiteV2Request} opts.body 
     * @param {module:api/DefaultApi~siteApiV1SiteGetByClientIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SiteV2Response}
     */
    this.siteApiV1SiteGetByClientId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SiteV2Response;

      return this.apiClient.callApi(
        '/siteApi/v1/siteGetByClientId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the siteApiV1SiteGetByCodeTag operation.
     * @callback module:api/DefaultApi~siteApiV1SiteGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SiteV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SiteV2Request} opts.body 
     * @param {module:api/DefaultApi~siteApiV1SiteGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SiteV2Response}
     */
    this.siteApiV1SiteGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SiteV2Response;

      return this.apiClient.callApi(
        '/siteApi/v1/siteGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the siteApiV1SiteGetById operation.
     * @callback module:api/DefaultApi~siteApiV1SiteGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SiteV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SiteV2Request} opts.body 
     * @param {module:api/DefaultApi~siteApiV1SiteGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SiteV2Response}
     */
    this.siteApiV1SiteGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SiteV2Response;

      return this.apiClient.callApi(
        '/siteApi/v1/siteGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the siteApiV1SiteGetBySiteId operation.
     * @callback module:api/DefaultApi~siteApiV1SiteGetBySiteIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SiteV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SiteV2Request} opts.body 
     * @param {module:api/DefaultApi~siteApiV1SiteGetBySiteIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SiteV2Response}
     */
    this.siteApiV1SiteGetBySiteId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SiteV2Response;

      return this.apiClient.callApi(
        '/siteApi/v1/siteGetBySiteId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the siteApiV1SiteUpdate operation.
     * @callback module:api/DefaultApi~siteApiV1SiteUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SiteV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SiteV2Request} opts.body 
     * @param {module:api/DefaultApi~siteApiV1SiteUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SiteV2Response}
     */
    this.siteApiV1SiteUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SiteV2Response;

      return this.apiClient.callApi(
        '/siteApi/v1/siteUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stationApiV1StationCreate operation.
     * @callback module:api/DefaultApi~stationApiV1StationCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StationRequest} opts.body 
     * @param {module:api/DefaultApi~stationApiV1StationCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StationResponse}
     */
    this.stationApiV1StationCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StationResponse;

      return this.apiClient.callApi(
        '/stationApi/v1/stationCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stationApiV1StationDelete operation.
     * @callback module:api/DefaultApi~stationApiV1StationDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StationRequest} opts.body 
     * @param {module:api/DefaultApi~stationApiV1StationDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StationResponse}
     */
    this.stationApiV1StationDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StationResponse;

      return this.apiClient.callApi(
        '/stationApi/v1/stationDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stationApiV1StationGetAllByCodeTagKanban operation.
     * @callback module:api/DefaultApi~stationApiV1StationGetAllByCodeTagKanbanCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StationRequest} opts.body 
     * @param {module:api/DefaultApi~stationApiV1StationGetAllByCodeTagKanbanCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StationResponse}
     */
    this.stationApiV1StationGetAllByCodeTagKanban = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StationResponse;

      return this.apiClient.callApi(
        '/stationApi/v1/stationGetAllByCodeTagKanban', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stationApiV1StationGetByCodeTag operation.
     * @callback module:api/DefaultApi~stationApiV1StationGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StationRequest} opts.body 
     * @param {module:api/DefaultApi~stationApiV1StationGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StationResponse}
     */
    this.stationApiV1StationGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StationResponse;

      return this.apiClient.callApi(
        '/stationApi/v1/stationGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stationApiV1StationGetById operation.
     * @callback module:api/DefaultApi~stationApiV1StationGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StationRequest} opts.body 
     * @param {module:api/DefaultApi~stationApiV1StationGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StationResponse}
     */
    this.stationApiV1StationGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StationResponse;

      return this.apiClient.callApi(
        '/stationApi/v1/stationGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stationApiV1StationGetByIdKanban operation.
     * @callback module:api/DefaultApi~stationApiV1StationGetByIdKanbanCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StationRequest} opts.body 
     * @param {module:api/DefaultApi~stationApiV1StationGetByIdKanbanCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StationResponse}
     */
    this.stationApiV1StationGetByIdKanban = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StationResponse;

      return this.apiClient.callApi(
        '/stationApi/v1/stationGetByIdKanban', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stationApiV1StationUpdate operation.
     * @callback module:api/DefaultApi~stationApiV1StationUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StationRequest} opts.body 
     * @param {module:api/DefaultApi~stationApiV1StationUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StationResponse}
     */
    this.stationApiV1StationUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StationResponse;

      return this.apiClient.callApi(
        '/stationApi/v1/stationUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stationApiV1StationUpdateByIdKanban operation.
     * @callback module:api/DefaultApi~stationApiV1StationUpdateByIdKanbanCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StationRequest} opts.body 
     * @param {module:api/DefaultApi~stationApiV1StationUpdateByIdKanbanCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StationResponse}
     */
    this.stationApiV1StationUpdateByIdKanban = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StationResponse;

      return this.apiClient.callApi(
        '/stationApi/v1/stationUpdateByIdKanban', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the statisticsApiV1CreateStatisticsTestData operation.
     * @callback module:api/DefaultApi~statisticsApiV1CreateStatisticsTestDataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StatisticsRequest} opts.body 
     * @param {module:api/DefaultApi~statisticsApiV1CreateStatisticsTestDataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StatisticsResponse}
     */
    this.statisticsApiV1CreateStatisticsTestData = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StatisticsResponse;

      return this.apiClient.callApi(
        '/statisticsApi/v1/createStatisticsTestData', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the statisticsApiV1StatisticsCreate operation.
     * @callback module:api/DefaultApi~statisticsApiV1StatisticsCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StatisticsRequest} opts.body 
     * @param {module:api/DefaultApi~statisticsApiV1StatisticsCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StatisticsResponse}
     */
    this.statisticsApiV1StatisticsCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StatisticsResponse;

      return this.apiClient.callApi(
        '/statisticsApi/v1/statisticsCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the statisticsApiV1StatisticsDelete operation.
     * @callback module:api/DefaultApi~statisticsApiV1StatisticsDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StatisticsRequest} opts.body 
     * @param {module:api/DefaultApi~statisticsApiV1StatisticsDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StatisticsResponse}
     */
    this.statisticsApiV1StatisticsDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StatisticsResponse;

      return this.apiClient.callApi(
        '/statisticsApi/v1/statisticsDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the statisticsApiV1StatisticsGetByCodeTag operation.
     * @callback module:api/DefaultApi~statisticsApiV1StatisticsGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StatisticsRequest} opts.body 
     * @param {module:api/DefaultApi~statisticsApiV1StatisticsGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StatisticsResponse}
     */
    this.statisticsApiV1StatisticsGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StatisticsResponse;

      return this.apiClient.callApi(
        '/statisticsApi/v1/statisticsGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the statisticsApiV1StatisticsGetByComparisonType operation.
     * @callback module:api/DefaultApi~statisticsApiV1StatisticsGetByComparisonTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StatisticsRequest} opts.body 
     * @param {module:api/DefaultApi~statisticsApiV1StatisticsGetByComparisonTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StatisticsResponse}
     */
    this.statisticsApiV1StatisticsGetByComparisonType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StatisticsResponse;

      return this.apiClient.callApi(
        '/statisticsApi/v1/statisticsGetByComparisonType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the statisticsApiV1StatisticsGetById operation.
     * @callback module:api/DefaultApi~statisticsApiV1StatisticsGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StatisticsRequest} opts.body 
     * @param {module:api/DefaultApi~statisticsApiV1StatisticsGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StatisticsResponse}
     */
    this.statisticsApiV1StatisticsGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StatisticsResponse;

      return this.apiClient.callApi(
        '/statisticsApi/v1/statisticsGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the statisticsApiV1StatisticsGetByReportType operation.
     * @callback module:api/DefaultApi~statisticsApiV1StatisticsGetByReportTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StatisticsRequest} opts.body 
     * @param {module:api/DefaultApi~statisticsApiV1StatisticsGetByReportTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StatisticsResponse}
     */
    this.statisticsApiV1StatisticsGetByReportType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StatisticsResponse;

      return this.apiClient.callApi(
        '/statisticsApi/v1/statisticsGetByReportType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the statisticsApiV1StatisticsUpdate operation.
     * @callback module:api/DefaultApi~statisticsApiV1StatisticsUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StatisticsRequest} opts.body 
     * @param {module:api/DefaultApi~statisticsApiV1StatisticsUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StatisticsResponse}
     */
    this.statisticsApiV1StatisticsUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StatisticsResponse;

      return this.apiClient.callApi(
        '/statisticsApi/v1/statisticsUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeAccountApiV1StripeAccountCreate operation.
     * @callback module:api/DefaultApi~stripeAccountApiV1StripeAccountCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeAccountRequest} opts.body 
     * @param {module:api/DefaultApi~stripeAccountApiV1StripeAccountCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeAccountResponse}
     */
    this.stripeAccountApiV1StripeAccountCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeAccountResponse;

      return this.apiClient.callApi(
        '/stripeAccountApi/v1/stripeAccountCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeAccountApiV1StripeAccountCreateWebhook operation.
     * @callback module:api/DefaultApi~stripeAccountApiV1StripeAccountCreateWebhookCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeAccountEventRequest} opts.body 
     * @param {module:api/DefaultApi~stripeAccountApiV1StripeAccountCreateWebhookCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeAccountResponse}
     */
    this.stripeAccountApiV1StripeAccountCreateWebhook = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeAccountResponse;

      return this.apiClient.callApi(
        '/stripeAccountApi/v1/stripeAccountCreateWebhook', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeAccountApiV1StripeAccountDelete operation.
     * @callback module:api/DefaultApi~stripeAccountApiV1StripeAccountDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeAccountRequest} opts.body 
     * @param {module:api/DefaultApi~stripeAccountApiV1StripeAccountDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeAccountResponse}
     */
    this.stripeAccountApiV1StripeAccountDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeAccountResponse;

      return this.apiClient.callApi(
        '/stripeAccountApi/v1/stripeAccountDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeAccountApiV1StripeAccountDeleteWebhook operation.
     * @callback module:api/DefaultApi~stripeAccountApiV1StripeAccountDeleteWebhookCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeAccountEventRequest} opts.body 
     * @param {module:api/DefaultApi~stripeAccountApiV1StripeAccountDeleteWebhookCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeAccountResponse}
     */
    this.stripeAccountApiV1StripeAccountDeleteWebhook = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeAccountResponse;

      return this.apiClient.callApi(
        '/stripeAccountApi/v1/stripeAccountDeleteWebhook', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeAccountApiV1StripeAccountGetByCodeTag operation.
     * @callback module:api/DefaultApi~stripeAccountApiV1StripeAccountGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeAccountRequest} opts.body 
     * @param {module:api/DefaultApi~stripeAccountApiV1StripeAccountGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeAccountResponse}
     */
    this.stripeAccountApiV1StripeAccountGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeAccountResponse;

      return this.apiClient.callApi(
        '/stripeAccountApi/v1/stripeAccountGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeAccountApiV1StripeAccountGetById operation.
     * @callback module:api/DefaultApi~stripeAccountApiV1StripeAccountGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeAccountRequest} opts.body 
     * @param {module:api/DefaultApi~stripeAccountApiV1StripeAccountGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeAccountResponse}
     */
    this.stripeAccountApiV1StripeAccountGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeAccountResponse;

      return this.apiClient.callApi(
        '/stripeAccountApi/v1/stripeAccountGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeAccountApiV1StripeAccountGetByStripeAccountId operation.
     * @callback module:api/DefaultApi~stripeAccountApiV1StripeAccountGetByStripeAccountIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeAccountRequest} opts.body 
     * @param {module:api/DefaultApi~stripeAccountApiV1StripeAccountGetByStripeAccountIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeAccountResponse}
     */
    this.stripeAccountApiV1StripeAccountGetByStripeAccountId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeAccountResponse;

      return this.apiClient.callApi(
        '/stripeAccountApi/v1/stripeAccountGetByStripeAccountId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeAccountApiV1StripeAccountUpdate operation.
     * @callback module:api/DefaultApi~stripeAccountApiV1StripeAccountUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeAccountRequest} opts.body 
     * @param {module:api/DefaultApi~stripeAccountApiV1StripeAccountUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeAccountResponse}
     */
    this.stripeAccountApiV1StripeAccountUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeAccountResponse;

      return this.apiClient.callApi(
        '/stripeAccountApi/v1/stripeAccountUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeAccountApiV1StripeAccountUpdateWebhook operation.
     * @callback module:api/DefaultApi~stripeAccountApiV1StripeAccountUpdateWebhookCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeAccountEventRequest} opts.body 
     * @param {module:api/DefaultApi~stripeAccountApiV1StripeAccountUpdateWebhookCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeAccountResponse}
     */
    this.stripeAccountApiV1StripeAccountUpdateWebhook = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeAccountResponse;

      return this.apiClient.callApi(
        '/stripeAccountApi/v1/stripeAccountUpdateWebhook', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeCustomerApiV1StripeCustomerCreate operation.
     * @callback module:api/DefaultApi~stripeCustomerApiV1StripeCustomerCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeCustomerResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeCustomerRequest} opts.body 
     * @param {module:api/DefaultApi~stripeCustomerApiV1StripeCustomerCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeCustomerResponse}
     */
    this.stripeCustomerApiV1StripeCustomerCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeCustomerResponse;

      return this.apiClient.callApi(
        '/stripeCustomerApi/v1/stripeCustomerCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeCustomerApiV1StripeCustomerCreateWebhook operation.
     * @callback module:api/DefaultApi~stripeCustomerApiV1StripeCustomerCreateWebhookCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeCustomerResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeCustomerEventRequest} opts.body 
     * @param {module:api/DefaultApi~stripeCustomerApiV1StripeCustomerCreateWebhookCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeCustomerResponse}
     */
    this.stripeCustomerApiV1StripeCustomerCreateWebhook = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeCustomerResponse;

      return this.apiClient.callApi(
        '/stripeCustomerApi/v1/stripeCustomerCreateWebhook', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeCustomerApiV1StripeCustomerDelete operation.
     * @callback module:api/DefaultApi~stripeCustomerApiV1StripeCustomerDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeCustomerResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeCustomerRequest} opts.body 
     * @param {module:api/DefaultApi~stripeCustomerApiV1StripeCustomerDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeCustomerResponse}
     */
    this.stripeCustomerApiV1StripeCustomerDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeCustomerResponse;

      return this.apiClient.callApi(
        '/stripeCustomerApi/v1/stripeCustomerDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeCustomerApiV1StripeCustomerDeleteWebhook operation.
     * @callback module:api/DefaultApi~stripeCustomerApiV1StripeCustomerDeleteWebhookCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeCustomerResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeCustomerEventRequest} opts.body 
     * @param {module:api/DefaultApi~stripeCustomerApiV1StripeCustomerDeleteWebhookCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeCustomerResponse}
     */
    this.stripeCustomerApiV1StripeCustomerDeleteWebhook = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeCustomerResponse;

      return this.apiClient.callApi(
        '/stripeCustomerApi/v1/stripeCustomerDeleteWebhook', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeCustomerApiV1StripeCustomerGetByCodeTag operation.
     * @callback module:api/DefaultApi~stripeCustomerApiV1StripeCustomerGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeCustomerResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeCustomerRequest} opts.body 
     * @param {module:api/DefaultApi~stripeCustomerApiV1StripeCustomerGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeCustomerResponse}
     */
    this.stripeCustomerApiV1StripeCustomerGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeCustomerResponse;

      return this.apiClient.callApi(
        '/stripeCustomerApi/v1/stripeCustomerGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeCustomerApiV1StripeCustomerGetById operation.
     * @callback module:api/DefaultApi~stripeCustomerApiV1StripeCustomerGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeCustomerResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeCustomerRequest} opts.body 
     * @param {module:api/DefaultApi~stripeCustomerApiV1StripeCustomerGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeCustomerResponse}
     */
    this.stripeCustomerApiV1StripeCustomerGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeCustomerResponse;

      return this.apiClient.callApi(
        '/stripeCustomerApi/v1/stripeCustomerGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeCustomerApiV1StripeCustomerGetByStripeCustomerId operation.
     * @callback module:api/DefaultApi~stripeCustomerApiV1StripeCustomerGetByStripeCustomerIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeCustomerResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeCustomerRequest} opts.body 
     * @param {module:api/DefaultApi~stripeCustomerApiV1StripeCustomerGetByStripeCustomerIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeCustomerResponse}
     */
    this.stripeCustomerApiV1StripeCustomerGetByStripeCustomerId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeCustomerResponse;

      return this.apiClient.callApi(
        '/stripeCustomerApi/v1/stripeCustomerGetByStripeCustomerId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeCustomerApiV1StripeCustomerUpdate operation.
     * @callback module:api/DefaultApi~stripeCustomerApiV1StripeCustomerUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeCustomerResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeCustomerRequest} opts.body 
     * @param {module:api/DefaultApi~stripeCustomerApiV1StripeCustomerUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeCustomerResponse}
     */
    this.stripeCustomerApiV1StripeCustomerUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeCustomerResponse;

      return this.apiClient.callApi(
        '/stripeCustomerApi/v1/stripeCustomerUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeCustomerApiV1StripeCustomerUpdateWebhook operation.
     * @callback module:api/DefaultApi~stripeCustomerApiV1StripeCustomerUpdateWebhookCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeCustomerResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeCustomerEventRequest} opts.body 
     * @param {module:api/DefaultApi~stripeCustomerApiV1StripeCustomerUpdateWebhookCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeCustomerResponse}
     */
    this.stripeCustomerApiV1StripeCustomerUpdateWebhook = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeCustomerResponse;

      return this.apiClient.callApi(
        '/stripeCustomerApi/v1/stripeCustomerUpdateWebhook', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeSubscriptionApiV1StripeSubscriptionCreate operation.
     * @callback module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeSubscriptionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeSubscriptionRequest} opts.body 
     * @param {module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeSubscriptionResponse}
     */
    this.stripeSubscriptionApiV1StripeSubscriptionCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeSubscriptionResponse;

      return this.apiClient.callApi(
        '/stripeSubscriptionApi/v1/stripeSubscriptionCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeSubscriptionApiV1StripeSubscriptionCreateFromWebhook operation.
     * @callback module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionCreateFromWebhookCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeSubscriptionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeSubscriptionEventRequest} opts.body 
     * @param {module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionCreateFromWebhookCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeSubscriptionResponse}
     */
    this.stripeSubscriptionApiV1StripeSubscriptionCreateFromWebhook = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeSubscriptionResponse;

      return this.apiClient.callApi(
        '/stripeSubscriptionApi/v1/stripeSubscriptionCreateFromWebhook', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeSubscriptionApiV1StripeSubscriptionDelete operation.
     * @callback module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeSubscriptionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeSubscriptionRequest} opts.body 
     * @param {module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeSubscriptionResponse}
     */
    this.stripeSubscriptionApiV1StripeSubscriptionDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeSubscriptionResponse;

      return this.apiClient.callApi(
        '/stripeSubscriptionApi/v1/stripeSubscriptionDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeSubscriptionApiV1StripeSubscriptionDeleteFromWebhook operation.
     * @callback module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionDeleteFromWebhookCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeSubscriptionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeSubscriptionEventRequest} opts.body 
     * @param {module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionDeleteFromWebhookCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeSubscriptionResponse}
     */
    this.stripeSubscriptionApiV1StripeSubscriptionDeleteFromWebhook = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeSubscriptionResponse;

      return this.apiClient.callApi(
        '/stripeSubscriptionApi/v1/stripeSubscriptionDeleteFromWebhook', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeSubscriptionApiV1StripeSubscriptionGetByCodeTag operation.
     * @callback module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeSubscriptionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeSubscriptionRequest} opts.body 
     * @param {module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeSubscriptionResponse}
     */
    this.stripeSubscriptionApiV1StripeSubscriptionGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeSubscriptionResponse;

      return this.apiClient.callApi(
        '/stripeSubscriptionApi/v1/stripeSubscriptionGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeSubscriptionApiV1StripeSubscriptionGetById operation.
     * @callback module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeSubscriptionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeSubscriptionRequest} opts.body 
     * @param {module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeSubscriptionResponse}
     */
    this.stripeSubscriptionApiV1StripeSubscriptionGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeSubscriptionResponse;

      return this.apiClient.callApi(
        '/stripeSubscriptionApi/v1/stripeSubscriptionGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeSubscriptionApiV1StripeSubscriptionGetByStripeSubscriptionId operation.
     * @callback module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionGetByStripeSubscriptionIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeSubscriptionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeSubscriptionRequest} opts.body 
     * @param {module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionGetByStripeSubscriptionIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeSubscriptionResponse}
     */
    this.stripeSubscriptionApiV1StripeSubscriptionGetByStripeSubscriptionId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeSubscriptionResponse;

      return this.apiClient.callApi(
        '/stripeSubscriptionApi/v1/stripeSubscriptionGetByStripeSubscriptionId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeSubscriptionApiV1StripeSubscriptionUpdate operation.
     * @callback module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeSubscriptionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeSubscriptionRequest} opts.body 
     * @param {module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeSubscriptionResponse}
     */
    this.stripeSubscriptionApiV1StripeSubscriptionUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeSubscriptionResponse;

      return this.apiClient.callApi(
        '/stripeSubscriptionApi/v1/stripeSubscriptionUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stripeSubscriptionApiV1StripeSubscriptionUpdateFromWebhook operation.
     * @callback module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionUpdateFromWebhookCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StripeSubscriptionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/StripeSubscriptionEventRequest} opts.body 
     * @param {module:api/DefaultApi~stripeSubscriptionApiV1StripeSubscriptionUpdateFromWebhookCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StripeSubscriptionResponse}
     */
    this.stripeSubscriptionApiV1StripeSubscriptionUpdateFromWebhook = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = StripeSubscriptionResponse;

      return this.apiClient.callApi(
        '/stripeSubscriptionApi/v1/stripeSubscriptionUpdateFromWebhook', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberCreate operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberDelete operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberGetByCodeTag operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberGetById operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberGetByMessages operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberGetByMessagesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberGetByMessagesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberGetByMessages = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberGetByMessages', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberGetByProjectId operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberGetByProjectIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberGetByProjectIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberGetByProjectId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberGetByProjectId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberGetByProjectName operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberGetByProjectNameCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberGetByProjectNameCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberGetByProjectName = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberGetByProjectName', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberGetByTopicId operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberGetByTopicIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberGetByTopicIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberGetByTopicId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberGetByTopicId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberGetByTopicName operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberGetByTopicNameCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberGetByTopicNameCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberGetByTopicName = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberGetByTopicName', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberPubSubGetByTopicId operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberPubSubGetByTopicIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberPubSubGetByTopicIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberPubSubGetByTopicId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberPubSubGetByTopicId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the subscriberApiV1SubscriberUpdate operation.
     * @callback module:api/DefaultApi~subscriberApiV1SubscriberUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SubscriberResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SubscriberRequest} opts.body 
     * @param {module:api/DefaultApi~subscriberApiV1SubscriberUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SubscriberResponse}
     */
    this.subscriberApiV1SubscriberUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SubscriberResponse;

      return this.apiClient.callApi(
        '/subscriberApi/v1/subscriberUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the topicApiV1TopicCreate operation.
     * @callback module:api/DefaultApi~topicApiV1TopicCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TopicResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TopicRequest} opts.body 
     * @param {module:api/DefaultApi~topicApiV1TopicCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TopicResponse}
     */
    this.topicApiV1TopicCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TopicResponse;

      return this.apiClient.callApi(
        '/topicApi/v1/topicCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the topicApiV1TopicDelete operation.
     * @callback module:api/DefaultApi~topicApiV1TopicDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TopicResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TopicRequest} opts.body 
     * @param {module:api/DefaultApi~topicApiV1TopicDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TopicResponse}
     */
    this.topicApiV1TopicDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TopicResponse;

      return this.apiClient.callApi(
        '/topicApi/v1/topicDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the topicApiV1TopicGetByCodeTag operation.
     * @callback module:api/DefaultApi~topicApiV1TopicGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TopicResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TopicRequest} opts.body 
     * @param {module:api/DefaultApi~topicApiV1TopicGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TopicResponse}
     */
    this.topicApiV1TopicGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TopicResponse;

      return this.apiClient.callApi(
        '/topicApi/v1/topicGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the topicApiV1TopicGetByDescription operation.
     * @callback module:api/DefaultApi~topicApiV1TopicGetByDescriptionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TopicResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TopicRequest} opts.body 
     * @param {module:api/DefaultApi~topicApiV1TopicGetByDescriptionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TopicResponse}
     */
    this.topicApiV1TopicGetByDescription = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TopicResponse;

      return this.apiClient.callApi(
        '/topicApi/v1/topicGetByDescription', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the topicApiV1TopicGetById operation.
     * @callback module:api/DefaultApi~topicApiV1TopicGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TopicResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TopicRequest} opts.body 
     * @param {module:api/DefaultApi~topicApiV1TopicGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TopicResponse}
     */
    this.topicApiV1TopicGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TopicResponse;

      return this.apiClient.callApi(
        '/topicApi/v1/topicGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the topicApiV1TopicPubSubGetByPlatform operation.
     * @callback module:api/DefaultApi~topicApiV1TopicPubSubGetByPlatformCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TopicResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TopicRequest} opts.body 
     * @param {module:api/DefaultApi~topicApiV1TopicPubSubGetByPlatformCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TopicResponse}
     */
    this.topicApiV1TopicPubSubGetByPlatform = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TopicResponse;

      return this.apiClient.callApi(
        '/topicApi/v1/topicPubSubGetByPlatform', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the topicApiV1TopicUpdate operation.
     * @callback module:api/DefaultApi~topicApiV1TopicUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TopicResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TopicRequest} opts.body 
     * @param {module:api/DefaultApi~topicApiV1TopicUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TopicResponse}
     */
    this.topicApiV1TopicUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TopicResponse;

      return this.apiClient.callApi(
        '/topicApi/v1/topicUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the typeformApiV1TypeformCreate operation.
     * @callback module:api/DefaultApi~typeformApiV1TypeformCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TypeformResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TypeformRequest} opts.body 
     * @param {module:api/DefaultApi~typeformApiV1TypeformCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TypeformResponse}
     */
    this.typeformApiV1TypeformCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TypeformResponse;

      return this.apiClient.callApi(
        '/typeformApi/v1/typeformCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the typeformApiV1TypeformDelete operation.
     * @callback module:api/DefaultApi~typeformApiV1TypeformDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TypeformResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TypeformRequest} opts.body 
     * @param {module:api/DefaultApi~typeformApiV1TypeformDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TypeformResponse}
     */
    this.typeformApiV1TypeformDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TypeformResponse;

      return this.apiClient.callApi(
        '/typeformApi/v1/typeformDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the typeformApiV1TypeformGetById operation.
     * @callback module:api/DefaultApi~typeformApiV1TypeformGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TypeformResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TypeformRequest} opts.body 
     * @param {module:api/DefaultApi~typeformApiV1TypeformGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TypeformResponse}
     */
    this.typeformApiV1TypeformGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TypeformResponse;

      return this.apiClient.callApi(
        '/typeformApi/v1/typeformGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the typeformApiV1TypeformUpdate operation.
     * @callback module:api/DefaultApi~typeformApiV1TypeformUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TypeformResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/TypeformRequest} opts.body 
     * @param {module:api/DefaultApi~typeformApiV1TypeformUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TypeformResponse}
     */
    this.typeformApiV1TypeformUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TypeformResponse;

      return this.apiClient.callApi(
        '/typeformApi/v1/typeformUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserAuthenticate operation.
     * @callback module:api/DefaultApi~userApiV1UserAuthenticateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserAuthenticateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserAuthenticate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userAuthenticate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserCreate operation.
     * @callback module:api/DefaultApi~userApiV1UserCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserCreateGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserCreateGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserCreateGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserCreateGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userCreateGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserDelete operation.
     * @callback module:api/DefaultApi~userApiV1UserDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserDeleteGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserDeleteGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserDeleteGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserDeleteGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userDeleteGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserGetAccount operation.
     * @callback module:api/DefaultApi~userApiV1UserGetAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserGetAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserGetAccount = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userGetAccount', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserGetAccountGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserGetAccountGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserGetAccountGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserGetAccountGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userGetAccountGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserListByRoleType operation.
     * @callback module:api/DefaultApi~userApiV1UserListByRoleTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserListByRoleTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserListByRoleType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userListByRoleType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserListInBusiness operation.
     * @callback module:api/DefaultApi~userApiV1UserListInBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserListInBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserListInBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userListInBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserListInBusinessGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserListInBusinessGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserListInBusinessGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserListInBusinessGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userListInBusinessGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserUpdateAccount operation.
     * @callback module:api/DefaultApi~userApiV1UserUpdateAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserUpdateAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserUpdateAccount = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userUpdateAccount', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserUpdateAccountGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserUpdateAccountGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserUpdateAccountGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserUpdateAccountGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userUpdateAccountGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workApiV1WorkCreate operation.
     * @callback module:api/DefaultApi~workApiV1WorkCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkV2Request} opts.body 
     * @param {module:api/DefaultApi~workApiV1WorkCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkV2Response}
     */
    this.workApiV1WorkCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkV2Response;

      return this.apiClient.callApi(
        '/workApi/v1/workCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workApiV1WorkDelete operation.
     * @callback module:api/DefaultApi~workApiV1WorkDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkV2Request} opts.body 
     * @param {module:api/DefaultApi~workApiV1WorkDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkV2Response}
     */
    this.workApiV1WorkDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkV2Response;

      return this.apiClient.callApi(
        '/workApi/v1/workDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workApiV1WorkGetActive operation.
     * @callback module:api/DefaultApi~workApiV1WorkGetActiveCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkV2Request} opts.body 
     * @param {module:api/DefaultApi~workApiV1WorkGetActiveCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkV2Response}
     */
    this.workApiV1WorkGetActive = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkV2Response;

      return this.apiClient.callApi(
        '/workApi/v1/workGetActive', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workApiV1WorkGetByCodeTag operation.
     * @callback module:api/DefaultApi~workApiV1WorkGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkV2Request} opts.body 
     * @param {module:api/DefaultApi~workApiV1WorkGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkV2Response}
     */
    this.workApiV1WorkGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkV2Response;

      return this.apiClient.callApi(
        '/workApi/v1/workGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workApiV1WorkGetByOrderId operation.
     * @callback module:api/DefaultApi~workApiV1WorkGetByOrderIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkV2Request} opts.body 
     * @param {module:api/DefaultApi~workApiV1WorkGetByOrderIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkV2Response}
     */
    this.workApiV1WorkGetByOrderId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkV2Response;

      return this.apiClient.callApi(
        '/workApi/v1/workGetByOrderId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workApiV1WorkUpdate operation.
     * @callback module:api/DefaultApi~workApiV1WorkUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkV2Request} opts.body 
     * @param {module:api/DefaultApi~workApiV1WorkUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkV2Response}
     */
    this.workApiV1WorkUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkV2Response;

      return this.apiClient.callApi(
        '/workApi/v1/workUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workItemApiV1WorkItemCreate operation.
     * @callback module:api/DefaultApi~workItemApiV1WorkItemCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkItemV2Request} opts.body 
     * @param {module:api/DefaultApi~workItemApiV1WorkItemCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkItemV2Response}
     */
    this.workItemApiV1WorkItemCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkItemV2Response;

      return this.apiClient.callApi(
        '/workItemApi/v1/workItemCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workItemApiV1WorkItemDelete operation.
     * @callback module:api/DefaultApi~workItemApiV1WorkItemDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkItemV2Request} opts.body 
     * @param {module:api/DefaultApi~workItemApiV1WorkItemDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkItemV2Response}
     */
    this.workItemApiV1WorkItemDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkItemV2Response;

      return this.apiClient.callApi(
        '/workItemApi/v1/workItemDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workItemApiV1WorkItemGetByCodeTag operation.
     * @callback module:api/DefaultApi~workItemApiV1WorkItemGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkItemV2Request} opts.body 
     * @param {module:api/DefaultApi~workItemApiV1WorkItemGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkItemV2Response}
     */
    this.workItemApiV1WorkItemGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkItemV2Response;

      return this.apiClient.callApi(
        '/workItemApi/v1/workItemGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workItemApiV1WorkItemGetById operation.
     * @callback module:api/DefaultApi~workItemApiV1WorkItemGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkItemV2Request} opts.body 
     * @param {module:api/DefaultApi~workItemApiV1WorkItemGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkItemV2Response}
     */
    this.workItemApiV1WorkItemGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkItemV2Response;

      return this.apiClient.callApi(
        '/workItemApi/v1/workItemGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workItemApiV1WorkItemGetByStatus operation.
     * @callback module:api/DefaultApi~workItemApiV1WorkItemGetByStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkItemV2Request} opts.body 
     * @param {module:api/DefaultApi~workItemApiV1WorkItemGetByStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkItemV2Response}
     */
    this.workItemApiV1WorkItemGetByStatus = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkItemV2Response;

      return this.apiClient.callApi(
        '/workItemApi/v1/workItemGetByStatus', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workItemApiV1WorkItemGetByWorkId operation.
     * @callback module:api/DefaultApi~workItemApiV1WorkItemGetByWorkIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkItemV2Request} opts.body 
     * @param {module:api/DefaultApi~workItemApiV1WorkItemGetByWorkIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkItemV2Response}
     */
    this.workItemApiV1WorkItemGetByWorkId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkItemV2Response;

      return this.apiClient.callApi(
        '/workItemApi/v1/workItemGetByWorkId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workItemApiV1WorkItemUpdate operation.
     * @callback module:api/DefaultApi~workItemApiV1WorkItemUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkItemV2Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WorkItemV2Request} opts.body 
     * @param {module:api/DefaultApi~workItemApiV1WorkItemUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkItemV2Response}
     */
    this.workItemApiV1WorkItemUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['api_key', 'firebase'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WorkItemV2Response;

      return this.apiClient.callApi(
        '/workItemApi/v1/workItemUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/api/DefaultApi.js